
let Vue = require('vue').default;

/**
 * The following block of code may be used to automatically register your
 * Vue components. It will recursively scan this directory for the Vue
 * components and automatically register them with their "basename".
 *
 * Eg. ./components/ExampleComponent.vue -> <example-component></example-component>
 */

// const files = require.context('./', true, /\.vue$/i)
// files.keys().map(key => Vue.component(key.split('/').pop().split('.')[0], files(key).default))
Vue.component('search-form', require('./searchForm/components/SearchForm.vue').default);

/**
 * Next, we will create a fresh Vue application instance and attach it to
 * the page. Then, you may begin adding components to this application
 * or customize the JavaScript scaffolding to fit your unique needs.
 */

import '../sass/searchForm/app.scss'
import mixins from './searchForm/mixins';

Vue.mixin(mixins);

Vue.config.productionTip = true;
Vue.config.devtools = true;
Vue.config.debug = process.env.APP_DEBUG;

const app = new Vue({
    el: '#app',
});
